function WarpigsLogo() {
  return (
    <img
      height="180"
      width="140"
      src="/logos/warpigs-logo.png"
      className="w-full h-full object-contain"
      alt="Warpigs Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { WarpigsLogo };
